import { render, staticRenderFns } from "./CoverSet.vue?vue&type=template&id=7b5ff32a&scoped=true&"
import script from "./CoverSet.vue?vue&type=script&lang=js&"
export * from "./CoverSet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b5ff32a",
  null
  
)

/* custom blocks */
import block0 from "./CoverSet.vue?vue&type=custom&index=0&blockType=i18nf"
if (typeof block0 === 'function') block0(component)

export default component.exports